import React from "react";
import BizProfileRoutes from "./routes";
import Layout from "components/layout";
import styled from "styled-components";
import Button from "components/button";

const ButtonWrapper = styled.div`
  display: flex;
  min-width: 16em;
  margin-left: auto;

  button {
    width: 100%;
  }
`;

const Icon = styled.img`
  width: 15px;
`;

export const HeaderButtons = (
  <ButtonWrapper>
    <Button variant="zltoDarkBlue" onClick={() => {}}>
      Download digital CV{" "}
      <Icon
        src={require("assets/images/download-icon.svg")}
        alt="Download digital cv"
      />
    </Button>
  </ButtonWrapper>
);

const BizProfile = () => (
  <Layout headerButtons={HeaderButtons}>
    <BizProfileRoutes />
  </Layout>
);
export default BizProfile;
